// Types
import { PublicTicketEventFields } from 'api/ticketEvents/types/PublicTicketEventFields';
// Constants
import { STREAM_DISCLAIMER } from 'constants/streams';
// Helpers
import { getStreamerAvatar, getStreamerName } from 'helpers/streams';
import {
  formatTicketEventSchedule,
  getTicketEventFullAddress,
} from 'helpers/ticketSales';
// Ui
import Modal from 'ui3/Modal/Modal';
import HashTags from 'ui3/HashTags/HashTags';
import MillionsIcon from 'ui3/MillionsIcon/MillionsIcon';
// Components
import TalentBlock from 'components/common3/TalentBlock/TalentBlock';
// Styles
import styles from './AboutEventModal.module.scss';

type AboutEventModalProps = {
  event: PublicTicketEventFields;
  open: boolean;
  onClose: () => void;
  /** Hides Follow on the host's own event. */
  isHost?: boolean;
  showDisclaimer?: boolean;
};

const AboutEventModal = ({
  event,
  open,
  onClose,
  isHost = false,
  showDisclaimer = false,
}: AboutEventModalProps): JSX.Element => {
  const { host, hashtags, description } = event;

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="small"
      showCloseIcon={false}
      className={styles.modal}
      modalStyles={{ padding: 0 }}
    >
      <div className={styles.root}>
        <div className={styles.header}>
          <h2 className={styles.title}>About Event</h2>
          <button
            type="button"
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Close"
          >
            <MillionsIcon name="close" size={24} />
          </button>
        </div>

        {description && (
          <section className={styles.section}>
            <h3 className={styles.sectionTitle}>OVERVIEW</h3>
            <p className={styles.overview}>{description}</p>
          </section>
        )}

        <section className={styles.section}>
          <h3 className={styles.sectionTitle}>DATE &amp; LOCATION</h3>
          <p className={styles.detail}>
            <MillionsIcon name="markerPin" size={18} />
            {getTicketEventFullAddress(event)}
          </p>
          <p className={styles.detail}>
            <MillionsIcon name="calendar" size={18} />
            {formatTicketEventSchedule(
              event.startsAt,
              event.endsAt,
              event.timezone
            )}
          </p>
        </section>

        {host && (
          <section className={styles.section}>
            <h3 className={styles.sectionTitle}>ORGANIZER</h3>
            <TalentBlock
              store={host}
              talentName={getStreamerName(host)}
              avatarURL={getStreamerAvatar(host.storeDetails)}
              profilePath={`/${host.slug}`}
              showFollowButton={!isHost}
            />
          </section>
        )}

        {hashtags.length > 0 && (
          <section className={styles.section}>
            <h3 className={styles.sectionTitle}>TAGS</h3>
            <HashTags tags={hashtags} variant="dark" />
          </section>
        )}

        {showDisclaimer && (
          <p className={styles.disclaimer}>
            <span>Disclaimer:</span> {STREAM_DISCLAIMER}
          </p>
        )}
      </div>
    </Modal>
  );
};

export default AboutEventModal;
